import React, { useState } from "react";
import {
  Alert,
  Button,
  FormControl,
  FormLabel,
  Select,
  Option,
  Stack,
  Typography,
} from "@mui/joy";
import RefreshIcon from "@mui/icons-material/Refresh";
import { DashboardRangeChoice, useDashboardContext } from "../DashboardContext";

const choices: { value: DashboardRangeChoice; label: string }[] = [
  { value: "24h", label: "Last 24 hours" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "custom", label: "Custom range" },
];

export const DashboardControls: React.FC = () => {
  const {
    rangeChoice,
    setRangeChoice,
    setCustomRange,
    rangeError,
    refresh,
    lastUpdatedAt,
  } = useDashboardContext();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      alignItems={{ sm: "end" }}
      sx={{ mb: 2 }}
    >
      <FormControl size="sm" sx={{ minWidth: 180 }}>
        <FormLabel>Time range</FormLabel>
        <Select
          aria-label="Time range"
          value={rangeChoice}
          onChange={(_, value) => value && setRangeChoice(value)}
        >
          {choices.map((choice) => (
            <Option key={choice.value} value={choice.value}>
              {choice.label}
            </Option>
          ))}
        </Select>
      </FormControl>
      {rangeChoice === "custom" && (
        <>
          <FormControl size="sm">
            <FormLabel>From (UTC)</FormLabel>
            <input
              aria-label="From UTC"
              type="datetime-local"
              value={from}
              onChange={(event) => setFrom(event.target.value)}
            />
          </FormControl>
          <FormControl size="sm">
            <FormLabel>To (UTC)</FormLabel>
            <input
              aria-label="To UTC"
              type="datetime-local"
              value={to}
              onChange={(event) => setTo(event.target.value)}
            />
          </FormControl>
          <Button
            size="sm"
            variant="outlined"
            onClick={() => setCustomRange(from, to)}
          >
            Apply range
          </Button>
        </>
      )}
      <Button
        size="sm"
        variant="soft"
        startDecorator={<RefreshIcon />}
        onClick={refresh}
      >
        Refresh
      </Button>
      <Typography
        level="body-xs"
        color="neutral"
        sx={{ ml: { sm: "auto !important" } }}
      >
        {lastUpdatedAt
          ? `Updated ${new Date(lastUpdatedAt).toLocaleString()}`
          : "Waiting for dashboard data"}
      </Typography>
      {rangeError && (
        <Alert color="danger" role="alert">
          {rangeError}
        </Alert>
      )}
    </Stack>
  );
};
